<template>
  <div v-if="isShow && handleMoney > 0.0" class="box1">
    <div v-if="isShowPic == '1'" class="img_box_tips1">
      <div class="tips_text1">&yen;{{ money }}</div>
    </div>
    <div v-if="isShowLinear == '1'" class="img_box_tips2">
      <div class="tips_text2">
        <span class="tips_icon">&yen;</span>
        <span class="tips_price">{{ money }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "top-tips",
  props: {
    money: {
      type: String,
      default() {
        return "0.00";
      },
    },
    isShowPic: {
      type: String,
      default() {
        return "0";
      },
    },
    isShowLinear: {
      type: String,
      default() {
        return "0";
      },
    },
    isShowText: {
      type: Boolean,
      default() {
        return true
      }
    }
  },
  data() {
    return {
      url: require("@/assets/home/tip_bg.png"),
    };
  },
  computed: {
    handleMoney() {
      return parseFloat(this.money).toFixed(2);
    },
    isShow() {
      return !this.$store.getters.identityDeal;
    },
  },
};
</script>

<style lang="scss" scoped>
.box1 {
  .img_box_tips1 {
    padding: vw(4) vw(25) vw(4) vw(6);
    background: url("../../../assets/home/tip_bg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .tips_text1 {
      margin-left: vw(6);
      color: #ffffff;
      font-size: vw(28);
    }
  }
  .img_box_tips2 {
    height: vw(42);
    line-height: vw(42);
    font-size: vw(22);
    background-color: #fff5eb;
    padding: 0 vw(16);
    border: 1px solid #fee9d8;
    border-radius: vw(30);
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .tips_text2 {
      color: #ff6900;
    }
    .tips_icon {
      display: inline-block;
      width: vw(26);
      font-size: vw(20);
      height: vw(26);
      color: #fff;
      line-height: vw(27);
      text-align: center;
      background-color: #ff6900;
      border-radius: 50%;
    }
    .tips_price {
      font-weight: 600;
      margin-left: vw(8);
    }
  }
}
</style>
